/* unplugin-vue-components disabled */import script from "./CategorySelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategorySelector.vue?vue&type=script&setup=true&lang=ts"

import "./CategorySelector.vue?vue&type=style&index=0&id=2cd527ad&lang=scss&scoped=true"
import "./CategorySelector.vue?vue&type=style&index=1&id=2cd527ad&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cd527ad"]])

export default __exports__